import { render } from "./ConfigurationMain.vue?vue&type=template&id=0b6e41fd"
import script from "./ConfigurationMain.vue?vue&type=script&lang=js"
export * from "./ConfigurationMain.vue?vue&type=script&lang=js"

import "./ConfigurationMain.vue?vue&type=style&index=0&id=0b6e41fd&lang=css"
script.render = render

export default script